// extracted by mini-css-extract-plugin
export default {"more":"ApprovalActions_more__01Rbq","menu":"ApprovalActions_menu__6aT9w"};